// extracted by mini-css-extract-plugin
module.exports = {"list":"list-module--list--t33UK","item":"list-module--item--3nnpy"};